/**
 * Checks if a value is a valid Date object
 * @param date - Value to check
 * @returns True if value is a valid Date, false otherwise
 */
export const isValidTimeValue = (date: Date | unknown): boolean => {
  return date instanceof Date && !isNaN(date.getTime())
}
